import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cancel",
  "use": "cancel-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"cancel\"><path fill=\"currentColor\" d=\"M9 18A9 9 0 1 1 9 0a9 9 0 0 1 0 18zm0-1A8 8 0 1 0 9 1a8 8 0 0 0 0 16zm.596-8.11l3.182 3.181-.707.707L8.89 9.596l-3.182 3.182L5 12.071 8.182 8.89 5 5.707 5.707 5 8.89 8.182 12.071 5l.707.707L9.596 8.89z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol